
import { useUI } from "providers/UIProvider"

import { Container } from "@chakra-ui/react"

import Modal from "components/UI/organisms/Modal"
import BookingSettingsForm from "components/templates/SettingsTemplate/BookingSettingsTemplate/BookingSettingsForm"

const ReservationSettingsModal = () => {
  const { modals, toggleModal, T } = useUI()

  return (
    <Modal
      isOpen={modals.reservationSettingsModal.isOpened}
      title={T("laundry.commission.booking_settings")}
      onClose={()=>toggleModal("reservationSettingsModal", false)}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "566px",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <Container>
        <BookingSettingsForm />
      </Container>
    </Modal>
  )
}

export default ReservationSettingsModal